import { render } from "./SoftPagination.vue?vue&type=template&id=17c80979"
import script from "./SoftPagination.vue?vue&type=script&lang=js"
export * from "./SoftPagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__